import { GetItemMetaDataInput, useGetItemMetaDataQuery } from '@graphql/generated/graphql';
import { useEffect } from 'react';
import logger from '@utils/logger';

const useGetItemMetaData = (input: GetItemMetaDataInput, options?: { enabled?: boolean }) => {
  const { enabled = true } = options ?? {};

  const { data, error, isError, isLoading, isSuccess } = useGetItemMetaDataQuery(
    {
      input,
    },
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled,
      retry: false,
    },
  );

  useEffect(() => {
    if (isError) {
      const { message, name } = error as Error;
      void logger.error(`Error occurred while retrieving item metadata: ${name}, ${message}`);
    }
  }, [isError, error]);

  return {
    isLoading,
    isSuccess,
    items: data?.getItemMetaData.items,
    error: data?.getItemMetaData.error,
  };
};

export default useGetItemMetaData;
